import styled from 'styled-components';
import colors from '../../config/colors';

const theme: any = {
  orange: {
    background: `${colors.ORANGE_COLOR}`,
    font_size: '14px',
    color: `${colors.WHITE}`,
    padding: '6px 20px',
    margin_bottom: '0',
  },
  red: {
    background: `${colors.PRIMARY_RED}`,
    font_size: '14px',
    color: `${colors.WHITE}`,
    padding: '6px 20px',
    margin_bottom: '0',
  },
  red_lg: {
    background: `${colors.PRIMARY_RED}`,
    font_size: '14px',
    color: `${colors.WHITE}`,
    padding: '6px 20px',
    margin_bottom: '0',
  },
  purple: {
    background: `${colors.PURPLE_COLOR}`,
    font_size: '14px',
    color: `${colors.WHITE}`,
    padding: '6px 20px',
    margin_bottom: '0',
  },
  gray: {
    background: `${colors.GRAY_BUTTON}`,
    font_size: '14px',
    color: `${colors.WHITE}`,
    padding: '6px 20px',
    margin_bottom: '0',
  },
  blue: {
    background: `${colors.BLUE_COLOR}`,
    font_size: '14px',
    color: `${colors.WHITE}`,
    padding: '6px 20px',
    margin_bottom: '0',
  },
  green: {
    background: `${colors.SUCCESS_GREEN}`,
    font_size: '14px',
    color: `${colors.WHITE}`,
    padding: '6px 20px',
    margin_bottom: '0',
  },
  light_gray: {
    background: `${colors.GRAY_EXTRA_LIGHT}`,
    font_size: '16px',
    color: `${colors.BLACK}`,
    padding: '16px 20px',
    margin_bottom: '10px',
  },
  pink: {
    background: `${colors.PRIMARY_PINK}`,
    font_size: '14px',
    color: `${colors.WHITE}`,
    padding: '6px 20px',
    margin_bottom: '0',
  }
};

const Tag = styled.span`
  background-color: ${props => theme[props.theme].background};
  padding: ${props => theme[props.theme].padding};
  color: ${props => theme[props.theme].color};
  font-size: ${props => theme[props.theme].font_size};
  font-family: "Gilroy-Bold";
  font-weight: 700;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
  margin-bottom: ${props => theme[props.theme].margin_bottom};
  margin-right: 12px;
  flex-wrap: wrap;
  text-align: center;

  @media (max-width: 576px) {
    padding: 8.5px 14px;
    font-size: 14px;
    margin-right: 4px;
    margin-bottom: 4px;
  }

  svg {
    margin-right: 10px;
  }

  b {
    margin-right: 5px;
  }

  span, i {
    margin-right: 5px;
    a {
      color: ${colors.BLACK};

      @media (max-width: 576px) {
        font-size: 14px;
      }

      &:hover {
        color: ${colors.PRIMARY_ORANGE};
      }
    }

    &:before {
      content: "";
      width: 1px;
      height: 13px;
      display: inline-block;
      vertical-align: middle;
      background: ${colors.TEXT_BLACK};
      margin-right: 5px;
    }

    &:first-of-type {
      &:before {
        display: none;
      }
    }
  }
`;

const TagSmRound = styled(Tag)`
  font-size: 12px;
  line-height: 22px;
  padding: 1.5px 18px;
  border-radius: 20px;
`;

const TagIcon = styled(Tag)`
  padding: 16px 20px 16px 46px;
  position: relative;

  @media (max-width: 576px) {
    width: 100%;
    padding: 10px 14px 10px 38px;
    font-size: 14px;
    margin: 0 0 4px;
  }

  svg {
    position: absolute;
    top: 16px;
    left: 20px;
    stroke: ${colors.PRIMARY_PURPLE};
    fill: ${colors.PRIMARY_PURPLE};

    @media (max-width: 576px) {
      width: 14px;
      height: 14px;
      top: 12px;
      left: 12px;
    }
  }
`;

export {
  Tag,
  TagSmRound,
  TagIcon
};
